import { OnboardingStepperSideMenu } from '../../_layout/OnboardingStepperSideMenu'

function IdentityVerificationSideMenu() {
  return <OnboardingStepperSideMenu />
}

export { IdentityVerificationSideMenu }
